/* eslint-disable */
var p = require('./package.json');
module.exports = p.version;



/*****************
 ** WEBPACK FOOTER
 ** ./config.version.js
 ** module id = 865
 ** module chunks = 0
 **/